import { render, staticRenderFns } from "./employeeLogin.vue?vue&type=template&id=254e0876&scoped=true"
import script from "./employeeLogin.vue?vue&type=script&lang=js"
export * from "./employeeLogin.vue?vue&type=script&lang=js"
import style0 from "./employeeLogin.vue?vue&type=style&index=0&id=254e0876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e0876",
  null
  
)

export default component.exports